import React from 'react';
import { Tooltip } from 'antd';
import { useAppDispatch, useAppSelector } from 'shared/store';
import { Icon } from 'shared/components/Icon';
import {
  selectAppNotificationsUnreadCount,
  uiWantsModalOpenChanged,
} from 'shared/store/app-notification-slice';
import './style.less';

const NAME = 'NavBarAppNotifications';
export const NavBarAppNotifications = () => {
  const dispatch = useAppDispatch();
  const hasCheckedUser = useAppSelector(s => s.auth.hasCheckedUser);

  const unreadCount = useAppSelector(selectAppNotificationsUnreadCount);
  const unreadRendered = unreadCount > 99 ? '99+' : unreadCount;

  const handleClick = () => {
    dispatch(uiWantsModalOpenChanged(true));
  };

  if (!hasCheckedUser) {
    return null;
  }

  return (
    <div className={`${NAME}`}>
      <Tooltip
        title={<>App notifications</>}
        overlayClassName="NavBar__tooltip"
        placement="right"
        mouseEnterDelay={0.1}
      >
        <button onClick={handleClick}>
          {!!unreadCount && <div className={`${NAME}__badge`}>{unreadRendered}</div>}
          <Icon icon="appNotificationsBell" className="fill" />
        </button>
      </Tooltip>
    </div>
  );
};
